import { configureStore } from '@reduxjs/toolkit';

import { IApplicationContext } from 'shared/mf-my-home/types/applicationContext';
import { IPreloadedState } from 'shared/mf-my-home/types/redux';
import {
  experimentsReducer,
  estimationTargetReducer,
  formFieldsReducer,
  submitFormReducer,
  pageReducer,
  newbuildingReducer,
} from '../../slices';

/**
 * Хелпер для создания Redux стора
 * @param context IApplicationContext - контекст приложения
 * @param preloadedState IPreloadedState - предзагруженное состояние
 * @param debugEnabled boolean - флаг доступности Redux Devtools на деве
 */
export function createReduxStore(context: IApplicationContext, preloadedState: IPreloadedState, debugEnabled: boolean) {
  const projectName = context.config.getStrict<string>('projectName');

  return configureStore({
    devTools: debugEnabled ? { name: projectName } : false,
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware({
        thunk: {
          extraArgument: context,
        },
      }),
    preloadedState,
    reducer: {
      experiments: experimentsReducer,
      formFields: formFieldsReducer,
      estimationTarget: estimationTargetReducer,
      submitForm: submitFormReducer,
      page: pageReducer,
      newbuilding: newbuildingReducer,
    },
  });
}
